export default function (waypoints) {
    return {
        errorMessage: "There was an error retrieving the position!",
        currentTimeout: -1,
        lastPosReturned: 0,

        _sanitizeLastReturned: function () {
            if (this.lastPosReturned > waypoints.length - 1) {
                return this.lastPosReturned = 0;
            }
            return undefined;
        },

        _geoCall: function (success, error) {
            let waypoint = waypoints[this.lastPosReturned];
            let nextWaypoint = waypoints[(<number> this.lastPosReturned) + 1];
            let delay = nextWaypoint ? nextWaypoint.timestamp - waypoint.timestamp : 1000;

            if (waypoint.fail && (error !== null)) {
                return this.currentTimeout = window.setTimeout(function () {
                    return error({code: 2, message: "Custom error: Timeout"});
                }, delay);
            } else {
                if (success !== null) {
                    return this.currentTimeout = window.setTimeout(() => {
                        success(waypoint);
                        waypoint = waypoints[this.lastPosReturned++];
                        return this._sanitizeLastReturned();
                    }, delay);
                }
            }
            return undefined;
        },

        getCurrentPosition: function (success, error) {
            return this._geoCall(success, error);
        },

        watchPosition: function (success, error) {
            this._geoCall((location) => {
                success(location);
                this.watchPosition(success, error);
            }, (e) => {
                error(e);
                this.watchPosition(success, error);
            });
            return this.currentTimeout;
        },

        clearWatch: function () {
            this.currentTimeout && clearTimeout(<number> this.currentTimeout);
        },

        MOCK: true
    };
}